import { Box, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { CustomMdChip } from '../components/Styles';
import { IconCloseChip } from './buttons/IconButtons';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const IngredientItem = ({ title, subtitle, unit, onClickClose, onClick }) => {
    const showClose = typeof onClickClose === 'function';

    return (
        <Box sx={CustomMdChip} onClick={onClick}>
            <div className='d-flex justify-content-between align-items-center w-100'>
                <Typography className='ibl-font-w-600 ibl-ientry-p'>
                    {title}
                </Typography>
                {showClose && (
                    <IconButton
                        size='small'
                        onClick={(e) => {
                            e.stopPropagation();
                            onClickClose();
                        }}
                    >
                        <IconCloseChip className='icon-color-shades-400'/>
                    </IconButton>
                )}
            </div>
            <div className={"border-top-shades-300 mt-2 mb-2"}>
                <Typography className='ibl-font-w-300 fs-12px mt-2'>
                    {subtitle} {unit}
                </Typography>
            </div>
        </Box>
    );
};

export default IngredientItem;
